import axios from "../Axios/Default";
import { handleResponse, getMultipartOptions } from "../Utils/Utils";

export const getProductsAll = (_params, onSuccess, onError) => {
  const response = axios.get(`v1/admin/product`, { params: _params });
  return handleResponse(response, onSuccess, onError);
};

export const getProduct = (item_code, page = undefined, onSuccess, onError) => {
  const response = axios.get(`v1/admin/product/${item_code}/${page}`);
  return handleResponse(response, onSuccess, onError);
};

export const getProductColor = (
  country_code,
  lang_code,
  onSuccess,
  onError
) => {
  const response = axios.get(
    `v1/admin/product/${country_code}/${lang_code}/color`
  );
  return handleResponse(response, onSuccess, onError);
};

export const getProductTag = (country_code, lang_code, onSuccess, onError) => {
  const response = axios.get(
    `v1/admin/product/${country_code}/${lang_code}/tag`
  );
  return handleResponse(response, onSuccess, onError);
};

export const createProduct = (payload, onSuccess, onError) => {
  const response = axios.post(
    `v1/admin/product`,
    payload,
    getMultipartOptions(axios)
  );
  return handleResponse(response, onSuccess, onError);
};

export const updateV2 = (itemCode, payload, onSuccess, onError) => {
  const response = axios.put(
    `v2/admin/product/${itemCode}`,
    payload,
    getMultipartOptions(axios)
  );
  //const response = axios.put(`v1/admin/product/${itemCode}`, payload);
  return handleResponse(response, onSuccess, onError, "generic");
};

export const saveDraft = (itemCode, payload, onSuccess, onError) => {
  const response = axios.post(
    `v1/admin/save-draft/${itemCode}`,
    payload,
    getMultipartOptions(axios)
  );
  //const response = axios.put(`v1/admin/product/${itemCode}`, payload);
  return handleResponse(response, onSuccess, onError, "generic");
};

export const updateProduct = (itemCode, payload, onSuccess, onError) => {
  const response = axios.put(
    `v1/admin/product/${itemCode}`,
    payload,
    getMultipartOptions(axios)
  );
  //const response = axios.put(`v1/admin/product/${itemCode}`, payload);
  return handleResponse(response, onSuccess, onError, "generic");
};

export const updateApprovalDetail = (itemCode, payload, onSuccess, onError) => {
  const response = axios.put(
    `v1/admin/product/${itemCode}/update-approval-detail`,
    payload,
    getMultipartOptions(axios)
  );
  return handleResponse(response, onSuccess, onError, "generic");
};

export const softDeleteProduct = (itemCode, payload, onSuccess, onError) => {
  const response = axios.put(`v1/admin/product/${itemCode}/delete`, payload);
  return handleResponse(response, onSuccess, onError);
};

export const webPublishProduct = (itemCode, payload, onSuccess, onError) => {
  const response = axios.put(`v1/admin/product/${itemCode}/publish`, payload);
  return handleResponse(response, onSuccess, onError);
};

// export const getWebSync = (itemCode, payload, onSuccess, onError) => {
//     const response = axios.post(`v1/admin/product/${itemCode}/web`, payload);
//     return handleResponse(response, onSuccess, onError);
// };

export const getWebSync = (itemCodes, onSuccess, onError) => {
  const data = {
    item_code: itemCodes,
  };
  const response = axios.post(`v1/admin/product/web`, data);
  return handleResponse(response, onSuccess, onError);
};
